import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import Icon from '@mui/material/SvgIcon';
import Checkmark from '@digital-hig/icon/lib/esm/display-icons/complete';
// eslint-disable-next-line import/no-extraneous-dependencies
import Grid from '@mui/material/Grid';
import Typography from '@digital-hig/mui/dist/Typography';
// eslint-disable-next-line import/no-extraneous-dependencies
import MUILink from '@mui/material/Link';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { triggerManualLinkClick, formatString } from './analyticsApi';
// import { styleVariables } from './constants';

const OutlineUnits = ({ units, curUnitId, analyticsPrefix }) => (
  // eslint-disable-next-line no-use-before-define
  <Grid className="accordion-units" component={RootElement}>
    {units.map((unit) => (
      <Grid component="li" key={unit.id} className={`${unit.isCompleted ? 'completed' : 'not-completed'} ${unit.id === curUnitId ? 'current-unit' : ''}`}>
        <Grid component="span">
          {unit.isCompleted ? (
            <Icon size="large"><Checkmark /></Icon>
          ) : (
            <span className="not-complete" />
          )}
        </Grid>
        <Grid>
          <Typography component="span" variant="short-copy-medium"><MUILink underline="none" component={Link} to={unit.uri} className="unit-link" onClick={() => { triggerManualLinkClick({ linkTitle: analyticsPrefix?.length ? `${analyticsPrefix}${formatString(unit.title)}:${unit.id}` : `unit:${formatString(unit.title)}` }); }}>{unit.title}</MUILink></Typography>
        </Grid>
      </Grid>
    ))}
  </Grid>
);

const RootElement = styled.ul`
    padding: 0;
    margin: 0;
    li {
      display: flex;
      align-items: center;
      position: relative;
      padding-bottom: 28px;
      gap: 8px;
      
      svg {
        width: 34px;
        height: 34px;
        position: relative;
        left: -2px;
      }

      &:not(:last-child)::before {
        content: "";
        position: absolute;
        width: 2px;
        height: 96%;
        left: 14px;
        top: 29px;
        background-color: rgba(0, 0, 0, 0.2);
      }
      :last-child {
        padding-bottom: 0;
      }
      .not-complete {
        width: 26px;
        height: 26px;
        border-radius: 100px;
        border: 2px solid #000;
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
      }
      &.not-completed {
        > span {
          height: 29px;
        }
      &.current-unit{
        a {
          font-weight: bold;
        }
        .not-complete{
          &:before {
            content: '';
            width: 8px;
            height: 8px;
            border-radius: 100px;
            background-color: #000;
          }
        }
      }
    }
`;

OutlineUnits.propTypes = {
  units: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  curUnitId: PropTypes.string.isRequired,
  analyticsPrefix: PropTypes.string,
};

OutlineUnits.defaultProps = {
  analyticsPrefix: '',
};

export default OutlineUnits;
